//services
import { signIn as _signIn } from '@/services/auth.api.js';

//utils
import sessionManager from '@/utils/managers/sessionManager.js';

//constants
import sessionKeys from '@/utils/sessionKeys.js';

export default {
  async login({ commit }, payload) {
    let { data: userInfo } = await _signIn(payload.username, payload.password);
    if (userInfo) {
      if (userInfo.validator.isValid) {
        commit('setUser', { ...userInfo });
        sessionManager.set(sessionKeys.KEY_USER_PROFILE, { ...userInfo });
      }
      return userInfo;
    }
  },
  async logout() {
    await sessionManager.clearAll();
  },
};
